export enum PhItemLineActivityTrackEnum{
    GRN ='GRN',
    INSPECTION ='INSPECTION',
    RELAXATION ='RELAXATION',
    LOCATION_ALLOCATION ='LOCATION ALLOCATION',
    MATERIAL_ALLOCATION =  'MATERIAL ALLOCATION',
    MATERIAL_ISSUANCE = 'MATERIAL ISSUANCE',
    MATERIAL_RETURN = 'MATERIAL RETURN',
}